import { useEffect, useRef } from 'react';
import './styless.scss';
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";

export default function PaymentRules(props: {}) {
    const {trackPaymentRulesShow} = useMatomoTrackingPoint();
    const targetRef = useRef<HTMLDivElement>(null);
    const trackedRef = useRef(false);

    useEffect(() => {
        const el = targetRef.current;
        if (!el) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !trackedRef.current) {
                    trackedRef.current = true;
                    trackPaymentRulesShow({
                        page_id: window.location.href,
                    });
                }
            });
        }, { threshold: 0.5 });

        observer.observe(el);
        return () => observer.disconnect();
    }, [trackPaymentRulesShow]);

    return (
        <div className="payment-rules">
            <div className="payment-rules__header">
                <div className="payment-rules__main-title">水滴规则 & 常见问题</div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">什么是水滴？</div>
                <div className="payment-rules__answer">
                    水滴是 Krene 全平台通用积分。<br/>
                    登录后，您可以在右上角查看当前水滴余额，或点击水滴余额查看详情。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">不同类型的水滴按什么顺序消耗？</div>
                <div className="payment-rules__answer">
                    如果您同时拥有多类型水滴，消耗顺序依次为「免费水滴」、「会员水滴」、「补给水滴」。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">如何获取水滴？</div>
                <div className="payment-rules__answer">
                    您可以通过充值获得水滴：<br/>
                    月度/年度会员（推荐）：可享受超值折扣、丰富权益，同时拥有更稳定流畅的使用体验！<br/>
                    水滴补给包：适合轻度使用，可按需灵活充值。<br/>
                    Krene 也会不定期上线各类免费领水滴活动，登录后可点击右上角「免费领水滴」参与活动。
                </div>
            </div>
            <div className="payment-rules__section" ref={targetRef}>
                <div className="payment-rules__question">
                    我的会员水滴会过期吗？
                </div>
                <div className="payment-rules__answer">
                    不同于多数同类产品每月清空会员积分，Krene 的会员水滴支持跨周期累积！<br/>
                    只要您在会员到期前及时「续购」或「升级」、保持会员身份连续生效，所有的会员水滴都会永久保留、长期有效，不会自动过期清零，可随时随心使用。<br/>
                    注意：若未在到期前及时「续购」或「升级」会员，而是在过期后重新开通会员，已失效的会员水滴将无法恢复。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">续购会员选择「立即生效」后，会员水滴和有效期如何计算？</div>
                <div className="payment-rules__answer">
                    选择立即生效后，支付成功会立刻发放本次续购赠送的会员水滴，会员新周期也会立即开始计算。<br/>
                    当前剩余会员有效期不再顺延。<br/>
                    例如：您在 4 月 20 日购买了「Max 月度会员」，有效期至 5 月 20 日；如果您在 5 月 5 日选择「立即生效」续购「Max
                    月度会员」，支付成功后会立即获得新一期会员水滴，会员有效期更新至 6 月 5 日。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">续购会员选择「到期生效」后，会员水滴和有效期如何计算？</div>
                <div className="payment-rules__answer">
                    选择到期生效后，当前会员周期会保持不变，本次续购会在当前周期结束后自动生效。<br/>
                    会员有效期会在当前有效期基础上顺延，剩余会员水滴有效期也会同步顺延，新一期会员水滴将在下一会员周期开始时发放。<br/>
                    例如：您在 4 月 20 日购买了「Max 月度会员」，有效期至 5 月 20 日；如果您在 5 月 5 日选择「到期生效」续购「Max 月度会员」，会员身份和剩余会员水滴有效期会延长至 6 月 20 日，并且在 5 月 20 日获得新一期会员水滴。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">升级会员后，会员水滴和有效期如何计算？</div>
                <div className="payment-rules__answer">
                    升级会员后，您可以立刻获得高等级会员专属水滴！会员有效期自升级当日重新计算，当前剩余会员水滴有效期也同步延长。<br/>
                    例如，您在 4 月 20 日购买了「Plus 月度会员」，并在 5 月 5 日升级为「Max 月度会员」，那么您会立刻获得「Max
                    月度会员」的会员水滴，会员身份和所有会员水滴的有效期都延长至 6 月 5 日。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">除了会员套餐，有没有其他选购方案？</div>
                <div className="payment-rules__answer">
                    Krene 提供灵活多样的选购方案，例如水滴补给包。您可以在水滴详情页查看所有当前在售方案。
                </div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">开通会员后，可以去除作品水印吗?</div>
                <div className="payment-rules__answer">是的，会员可以一键去除水印，直接下载 / 复制高清原图。</div>
            </div>
            <div className="payment-rules__section">
                <div className="payment-rules__question">图片生成失败，会扣除水滴吗？</div>
                <div className="payment-rules__answer">
                    如果生图模型未产出图片结果，不会扣除水滴。<br/>
                    注意：如果使用「智能模式」生图，仅调用大模型返回文本内容，仍会扣除文本对应水滴消耗。
                </div>
            </div>
        </div>
    );
}
